import { Box, BoxProps } from '@mui/material';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

interface ArrayAsRowsProps extends ICasRenderCellProps {
  textAlign?: BoxProps['textAlign'];
}

export function CasRenderArrayAsRows({ row, column, textAlign }: ArrayAsRowsProps) {
  return getCasTableCellValue({ row, column })?.map((item: string, index: number) => (
    <Box key={`${index}${item}`} textAlign={textAlign}>
      {item}
    </Box>
  ));
}
